import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { logger } from 'core/logger';
import { appInsights } from 'core/logger/ApplicationInsightsService';
import { useState } from 'react';

export const useCopyToClipboard = () => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
      return true;
    } catch (error) {
      const errorMessage = 'Failed to copy text to clipboard';
      logger?.warn(error, errorMessage);
      appInsights?.trackException({
        error: new Error(errorMessage),
        severityLevel: SeverityLevel.Warning,
      });
      return false;
    }
  };

  return { copied, copyToClipboard };
};
